// extracted by mini-css-extract-plugin
module.exports = {"payment-button":"ButtonPayment_payment-button__obFyG","secure":"ButtonPayment_secure__VOdn5"};